module.exports = __webpack_public_path__ + "static/media/wf.05522b9f.svg";